import { render, staticRenderFns } from "./Eye3.vue?vue&type=template&id=4fb736d9&"
import script from "./Eye3.vue?vue&type=script&lang=js&"
export * from "./Eye3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports